export const days = (date) => {
  // This is primarily to catch missing "modified: <data>" in config.txt
  if (date === undefined) return '';

  const oneDayInMilliseconds = 1000 * 60 * 60 * 24;
  const today = new Date();
  const datestamp = new Date(date);
  const result = Math.round(today.getTime() - datestamp.getTime()) / oneDayInMilliseconds;
  const days = parseInt(result);

  if (days === 0) {
    return 'today';
  }
  if (days === 1) {
    return '1 day ago';
  }
  if (days > 0 && days < 8) {
    return `${days} days ago`;
  }
  return `${datestamp.toLocaleDateString('us-en', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  })}`;
};
